import { supabase } from './supabase.js'
import { USER_CHART_PREFERENCES_TABLE, writeServerChartPreference } from './chart/chartPreferenceStore.js'

const scope = 'position-workspace'
const preferenceKey = 'watchlist-icon-order'

export function normalizeWatchlistIconOrder(value) {
  return [...new Set((Array.isArray(value) ? value : []).filter(id => typeof id === 'string' && id.length > 0))]
}

export function orderWatchlists(lists, order) {
  const byId = new Map(lists.map(list => [list.listId, list]))
  const ordered = normalizeWatchlistIconOrder(order).flatMap(id => byId.has(id) ? [byId.get(id)] : [])
  const included = new Set(ordered.map(list => list.listId))
  return [...ordered, ...lists.filter(list => !included.has(list.listId))]
}

export async function readWatchlistIconOrder(userId) {
  if (!userId) throw new Error('Sign in to reorder watchlists.')
  // Unlike a missing row, a failed read must not enable writes over an unknown order.
  const { data, error } = await supabase.from(USER_CHART_PREFERENCES_TABLE)
    .select('preferences').eq('user_id', userId).eq('scope', scope)
    .eq('preference_key', preferenceKey).maybeSingle()
  if (error) throw error
  return normalizeWatchlistIconOrder(data?.preferences?.listIds)
}

export async function writeWatchlistIconOrder(userId, listIds) {
  if (!userId) throw new Error('Sign in to reorder watchlists.')
  const saved = await writeServerChartPreference({
    userId, scope, preferenceKey, preferences: { listIds: normalizeWatchlistIconOrder(listIds) },
  })
  if (!saved) throw new Error('Could not save watchlist order. Try again.')
}
